import loadable from '@loadable/component';
import type { Rectangle } from '@glideapps/glide-data-grid';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';

import type { getTickerCellTemplate } from '../../../CustomCell/Ticker';

const TickerRematchPopover = loadable(() => import('./TickerRematchPopover'), {
  resolveComponent: (module) => module.TickerRematchPopover,
});
const TickerRematchModal = loadable(() => import('./TickerRematchModal'), {
  resolveComponent: (module) => module.TickerRematchModal,
});

type Props = {
  cell: Rectangle | null;
  oldValue: ReturnType<typeof getTickerCellTemplate>;
  newValue: ReturnType<typeof getTickerCellTemplate>;
  matchRowCount: number;
  onConfirm: () => void;
  onCancel: () => void;
};

export const TickerRematchOverlay = ({
  cell,
  oldValue,
  newValue,
  matchRowCount,
  onConfirm,
  onCancel,
}: Props) => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  return isMobileScreen ? (
    <TickerRematchModal
      matchRowCount={matchRowCount}
      oldValue={oldValue}
      newValue={newValue}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  ) : (
    <TickerRematchPopover
      cell={cell}
      oldValue={oldValue}
      newValue={newValue}
      matchRowCount={matchRowCount}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
